import { Editor } from '@tinymce/tinymce-react';

export type TinyMCE = Editor['editor'];

export enum FormatType {
  bold = 'bold',
  italic = 'italic',
  underline = 'underline',
}

export enum FormatChangeListenerEvent {
  FormatApply = 'FormatApply',
  FormatRemove = 'FormatRemove',
  SelectionChange = 'SelectionChange',
  NodeChange = 'NodeChange',
}

export enum FocusChangeListenerEvent {
  Focus = 'focus',
  Blur = 'blur',
  FocusIn = 'focusin',
  FocusOut = 'focusout',
}

export enum ContentChangeListenerEvent {
  Change = 'Change',
}

export enum SelectionChangeListenerEvent {
  SelectionChange = 'SelectionChange',
}

export enum ClickListenerEvent {
  DoubleClick = 'dblclick',
}

export type NodeReplacement<ReplaceThis extends Node = Node, WithThis extends Node = Node> = [
  ReplaceThis,
  WithThis,
];

export enum MergeTagType {
  User = 'User',
  Event = 'Event',
}

export type MergeTag = {
  type: MergeTagType;
  fieldName: string;
};
